// extracted by mini-css-extract-plugin
module.exports = {"cell":"Item_cell__2J1kB"};